import { render, staticRenderFns } from "./Badges_Section_Header.vue?vue&type=template&id=20d0499c&"
import script from "./Badges_Section_Header.vue?vue&type=script&lang=js&"
export * from "./Badges_Section_Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports